<template>
  <div id="expenditure">
    <div v-if="state==1">
      <el-tabs type="border-card" v-model="label">
        <el-tab-pane label="项目列表" name="1">
          <div v-if="empty" align="center">
            <div style="padding:20px 0;">

              <img :src="serve + '/image/none/none_img3.jpg'" alt="">
            </div>
            <div style="margin-bottom:50px;">
              <router-link to="/user/expenditure/2/3">
                <el-button type="primary" style="width:100px;" size="mini">去上传</el-button>
              </router-link>
            </div>
          </div>
          <div v-if="!empty">
            <div v-for="(item,index) of data" :key="index" class="table">
              <div class="t2">{{index+1}}</div>
              <table
                width="800"
                border="1"
                cellpadding="0"
                cellspacing="0"
                bordercolor="#ddd"
                style="border-collapse:collapse;margin-bottom:30px;"
              >
                <tr>
                  <td class="t" width="100">项目编号：</td>
                  <td class="v" width="700">{{item.project_no}}</td>
                </tr>
                <tr>
                  <td class="t">项目名称：</td>
                  <td class="v">{{item.project_name}}</td>
                </tr>
                <tr>
                  <td class="t">总金额：</td>
                  <td class="v">{{item.project_money}}</td>
                </tr>
                <tr>
                  <td class="t">直接费用：</td>
                  <td class="v">{{item.direct}}</td>
                </tr>
                <tr>
                  <td class="t">间接费用：</td>
                  <td class="v">{{item.indirect}}</td>
                </tr>
                <tr>
                  <td class="t">负责人：</td>
                  <td class="v">{{item.charge_name}}</td>
                </tr>
                <tr>
                  <td class="t">合作单位：</td>
                  <td class="v">{{item.cooperator}}</td>
                </tr>
                <tr>
                  <td class="t">开始时间：</td>
                  <td class="v">{{item.start_time}}</td>
                </tr>
                <tr>
                  <td class="t">结束时间：</td>
                  <td class="v">{{item.end_time}}</td>
                </tr>
                <tr>
                  <td class="t">经费来源：</td>
                  <td class="v">{{item.money_source}}</td>
                </tr>
                <tr>
                  <td class="t">操作：</td>
                  <td class="v">
                    <el-link @click="del(item.id)">删除</el-link>
                    <router-link :to="'/user/manage/'+item.id">
                      <el-link>资金调整</el-link>
                    </router-link>
                    <router-link :to="'/user/viewEx/'+item.id">
                      <el-link>查看详情</el-link>
                    </router-link>
                    <el-link @click="openUsing(item.id)">经费使用</el-link>
                  </td>
                </tr>
              </table>
            </div>
            <div v-if="empty==false" style="padding: 20px;" align="center">
              <el-pagination
                background
                hide-on-single-page
                layout="prev, pager, next"
                :total="total"
                :page-size="5"
                @current-change="changePage"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="添加项目" name="2">
          <div style="padding:30px 0;">
            <el-form label-position="right" label-width="100px" style="width:600px;margin:0 auto;">
              <el-form-item label="项目编号：">
                <el-input v-model="form.project_no" style="width:350px;"></el-input>
              </el-form-item>
              <el-form-item label="项目名称：">
                <el-input v-model="form.project_name" style="width:350px;"></el-input>
              </el-form-item>
              <el-form-item label="经费来源：">
                <el-input v-model="form.money_source" style="width:350px;"></el-input>
              </el-form-item>
              <el-form-item label="项目总金额：">
                <el-input v-model="form.project_money" style="width:350px;">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
              <el-form-item label="项目期限：">
                <el-col :span="11">
                  <el-form-item>
                    <el-date-picker
                      type="date"
                      placeholder="选择日期"
                      v-model="form.start_time"
                      style="width: 100%;"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="2">至</el-col>
                <el-col :span="11">
                  <el-form-item>
                    <el-date-picker
                      type="date"
                      placeholder="选择日期"
                      v-model="form.end_time"
                      style="width: 100%;"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>
              <el-form-item label="直接经费：">
                <el-input v-model="form.direct" style="width:350px;" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item>
                <div>
                  <el-row :gutter="5">
                    <el-col :span="8">
                      <div>
                        <el-input v-model="form.equipment" style="width:150px" placeholder="设备费">
                          <template slot="append">元</template>
                        </el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div>
                        <el-input v-model="form.consult" style="width:150px" placeholder="咨询费">
                          <template slot="append">元</template>
                        </el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div>
                        <el-input v-model="form.material" style="width:150px" placeholder="材料费">
                          <template slot="append">元</template>
                        </el-input>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
              <el-form-item label="间接费用：">
                <el-input v-model="form.indirect" style="width:350px;"></el-input>
              </el-form-item>
              <el-form-item label="负责人：">
                <el-input v-model="form.charge_name" style="width:350px;"></el-input>
              </el-form-item>
              <el-form-item label="合作单位：">
                <div>
                  <el-input style="width:350px;" v-model="input[0]"></el-input>
                  <span
                    class="lv3Text addBtn"
                    style="margin-left:10px;cursor: pointer;"
                    @click="add"
                    v-if="list < 5"
                  >
                    <span>
                      <i class="fas fa-plus-square fa-lg"></i>
                    </span>
                    点击添加更多
                  </span>
                </div>
                <div v-for="n in (list-1)" :key="n" style="margin-top:10px">
                  <el-input style="width:350px;" v-model="input[n]"></el-input>
                </div>
              </el-form-item>
            </el-form>
            <div align="center" style="margin-top:30px;">
              <el-button type="primary" style="width:150px;" @click="submit">提交</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <el-dialog title="经费使用" :visible.sync="usingDialog" width="500px" center>
        <div>
          <el-form label-position="right" label-width="80px">
            <el-form-item label="分类：">
              <el-button plain @click="printClass='咨询费'" :class="printClass=='咨询费'?'active':''">咨询费</el-button>
              <el-button plain @click="printClass='设备费'" :class="printClass=='设备费'?'active':''">设备费</el-button>
              <el-button plain @click="printClass='材料费'" :class="printClass=='材料费'?'active':''">材料费</el-button>
              <div style="margin-top:20px">
                <span v-for="(item,index) in classArr" :key="index">
                  <div v-if="item.class==printClass">
                    <span v-for="(item2,index2) in item.children" :key="index2">
                      <el-button
                        style="margin:5px;"
                        plain
                        @click="secondClass=item2"
                        :class="secondClass==item2?'active':''"
                        size="mini"
                      >{{item2}}</el-button>
                    </span>
                  </div>
                </span>
              </div>
            </el-form-item>
            <el-form-item label="金额：">
              <el-input v-model="form2.money" style="width:200px;"></el-input>
            </el-form-item>
            <el-form-item label="使用人：">
              <el-input v-model="form2.name" style="width:200px;"></el-input>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input v-model="form2.info" type="textarea" :rows="2" style="width:250px;"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submit2">提交</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-if="state==0" style="background-color:#fff;padding-bottom:250px;">
      <div style="width:500px;margin:0 auto;">
        <img :src="serve +'/image/none/noOpenHost.jpg'" style="width:500px;" />
      </div>
      <div class="lv3Text" align="center" style="font-size:18px;margin-top:50px">
        <div style="margin-bottom:5px;">您暂时没有权限使用经费管理功能，请联系</div>
        <div>
          24小时电话
          <span class="lv0Text">133 1168 8691</span> 开通后即可使用
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      state: null,
      label:
        _.toInteger(this.$route.params.id) > 2
          ? _.toInteger(this.$route.params.id) - 2 + ""
          : this.$route.params.id,
      form: {},
      form2: {},
      list: 1,
      input: [],
      empty: null,
      data: {},
      page: 1,
      total: 0,
      usingDialog: false,
      classArr: [],
      secondClass: "",
      params: "",
      printClass: null,
      params: "",
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token")
    };
  },
  activated() {
    this.$store.state.user_location = "经费管理";
  },
  created() {
    this.initData();
  },
  watch: {
    printClass(v) {
      this.form2.class = v;
    },
    secondClass(v) {
      this.form2.class = v;
    },
    form: {
      handler(v) {
        this.form.direct =
          _.toInteger(this.form.equipment) +
          _.toInteger(this.form.consult) +
          _.toInteger(this.form.material);
        this.form.indirect =
          _.toInteger(this.form.project_money) - _.toInteger(this.form.direct);
      },
      deep: true
    },
    input: {
      handler(v) {
        this.form.cooperator = "";
        for (var item of v) {
          this.form.cooperator = this.form.cooperator + ";" + item;
        }
      }
    }
  },
  methods: {
    alert_success(message) {
      this.$message({
        message: message,
        type: "success",
        offset: 200
      });
    },
    alert_error(message) {
      this.$message({
        message: message,
        type: "error",
        offset: 200
      });
    },
    openUsing(id) {
      this.usingDialog = true;
      this.form2.project_id = id;
    },
    submit2() {
      this.form2.mobile = this.mobile;
      this.form2.token = this.token;
      this.axios
        .get(this.serve + "/personal/use_money", {
          params: this.form2
        })
        .then(res => {
          if (res.data.status == "success") {
            this.alert_success("操作成功");
            this.usingDialog = false;
            this.form2 = {};
          } else {
            this.alert_error(res.data.msg);
          }
        });
    },
    del(id) {
      this.$confirm("您的操作将删除您添加的项目, 是否继续?", "项目删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/personal/del_project", {
              params: {
                mobile: this.$cookies.get("user"),
                token: this.$cookies.get("token"),
                id: id
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.alert_success("项目已删除");
                this.axios
                  .get(this.serve + "/personal/my_project_list", {
                    params: {
                      mobile: this.$cookies.get("user"),
                      token: this.$cookies.get("token"),
                      page: this.page
                    }
                  })
                  .then(res => {
                    if (res.data.data.total > 0) {
                      this.data = res.data.data.list;
                      this.total = res.data.data.total;
                      this.empty = false;
                    } else {
                      this.empty = true;
                    }
                  });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            offset: 200
          });
        });
    },
    changePage(p) {
      this.page = p;
      this.axios
        .get(this.serve + "/personal/my_project_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: this.page
          }
        })
        .then(res => {
          if (res.data.data.total > 0) {
            this.data = res.data.data.list;
            this.total = res.data.data.total;
            this.empty = false;
          } else {
            this.empty = true;
          }
        });
    },
    submit() {
      this.form.mobile = this.mobile;
      this.form.token = this.token;
      this.axios
        .get(this.serve + "/personal/add_my_project", {
          params: this.form
        })
        .then(res => {
          if (res.data.status == "success") {
            this.alert_success("项目上传成功");
            this.label = "1";
            this.initData();
            this.form = {};
          } else {
            this.alert_error(res.data.msg);
          }
        });
    },
    add() {
      if (this.list < 5) {
        this.list++;
      }
    },
    initData() {
      this.axios
        .get(this.serve + "/personal/is_open_host", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data == 1) {
            this.state = 1;
            this.axios
              .get(this.serve + "/personal/my_project_list", {
                params: {
                  mobile: this.$cookies.get("user"),
                  token: this.$cookies.get("token"),
                  page: 1
                }
              })
              .then(res => {
                if (res.data.data.total > 0) {
                  this.data = res.data.data.list;
                  this.total = res.data.data.total;
                  this.empty = false;
                } else {
                  this.empty = true;
                }
              });

            this.axios
              .get(this.serve + "/personal/project_class", {
                params: {
                  mobile: this.$cookies.get("user"),
                  token: this.$cookies.get("token")
                }
              })
              .then(res => {
                this.classArr = res.data;
              });
          } else if (res.data == 0) {
            this.state = 0;
          }
        });
    }
  }
};
</script>
<style lang="scss">
#expenditure {
  .el-tabs__content {
    min-height: 600px;
  }
  .addBtn:hover {
    color: #e2211c;
  }
  .el-button.active {
    color: #e2211c;
    border: 1px solid #e2211c;
  }
  .table {
    .t {
      background-color: #f5faf9;
      padding: 10px 20px;
    }
    .v {
      padding: 10px 20px;
      .el-link {
        margin-right: 20px;
      }
    }
    .t2 {
      background-color: #f5f5f5;
      color: #ccc;
      width: 180px;
      line-height: 24px;
      font-weight: bold;
      margin: 0 auto;
      text-align: center;
      font-size: 18px;
      margin-bottom: 30px;
    }
  }
}
</style>